import { render } from "./SnippetTopBar.vue?vue&type=template&id=1e05babe&scoped=true"
import script from "./SnippetTopBar.vue?vue&type=script&lang=js"
export * from "./SnippetTopBar.vue?vue&type=script&lang=js"

import "./SnippetTopBar.vue?vue&type=style&index=0&id=1e05babe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e05babe"]])

export default __exports__